module.exports = __webpack_public_path__ + "img/intro-pc-hagukumu.a6efe94a.jpg";